import React from 'react'

import { defaultTaskListContext, TaskListContextType } from './defaultTaskListContext'

export const TaskListContext = React.createContext<TaskListContextType>(defaultTaskListContext)
